<template>
  <div class="link_cnt"
    @click="linkBtnClickHandler"
    :class="{slider:isSlider, no_silder:!isSlider}">
    <span class="text">
      <slot></slot>
    </span>
    <i v-if="type === 'text'"
      class="iconfont gm-close"></i>
    <i v-if="type === 'close'"
      class="iconfont gm-close"></i>
    <i v-if="type === 'edit'"
      class="iconfont oaicon-editer"></i>
    <i v-if="type === 'edit2'"
      class="iconfont oaicon-editer"></i>
    <i v-if="type === 'out_link'"
      class="iconfont gm-yuanjiaojuxingkaobei2"></i>
    <i v-if="type === 'right_out_link'"
      class="iconfont gm-weibiaoti34"></i>
    <i v-if="type === 'top_right_out_link'"
      class="iconfont gm-tuoyuan1"></i>
    <i v-if="type === 'refresh'"
      class="iconfont gm-shuaxin"></i>
    <i v-if="type === 'add'"
      class="iconfont gm-tianjia"></i>
    <i v-if="type === 'import'"
      class="iconfont gm-daoru1"></i>
    <i v-if="type === 'delete'"
      class="iconfont  gm-lajitong"></i>
    <i v-if="type === 'setting'"
      class="iconfont  gm-shezhi2"></i>
    <i v-if="type === 'custom'"
      :class="`iconfont ${iconClass}`"></i>
    <span class="text">
      <slot name="right"></slot>
    </span>
    <template>
      <transition name="el-zoom-in-top">
        <div class="slider_container"
          @click.stop=""
          v-if="isSlider && sliderIsDown">
          <s class="top_arrows"></s>
          <slot name="slider"></slot>
        </div>
      </transition>
    </template>
  </div>
</template>
<script>
export default {
  name: 'az-link',
  props: {
    type: {
      type: String,
      default: 'text_link' // text_link  out_link edit  close delete
    },
    iconClass: {
      type: String
    },
    isSlider: {
      type: Boolean,
      default: false
    },
    /**
     * 可以拦截打开
     */
    beforeDownHandler: {
      type: Function,
      default: next => {
        next();
      }
    },
    sliderDownHandler: {
      type: Function,
      default: () => { }
    },
    /**
     * 可以拦截关闭
     */
    beforeUpHandler: {
      type: Function,
      default: next => {
        next();
      }
    },
    sliderUpHandler: {
      type: Function,
      default: () => { }
    },
    initDown: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sliderIsDown: false
    };
  },
  created() {
    this.sliderIsDown = this.initDown;
  },
  mounted() {
    this.$on('slider', (isDown = false) => {
      this.sliderIsDown = isDown;
    });
  },
  methods: {
    linkBtnClickHandler(event) {
      if (!this.isSlider) return;
      if (this.sliderIsDown) {
        // 收起前
        this.beforeUpHandler(() => {
          this.sliderIsDown = false;
          this.sliderUpHandler(); // 已收起
        });
      } else {
        // 下落前
        this.beforeDownHandler(() => {
          this.sliderIsDown = true;
          this.sliderDownHandler(); // 已落下
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.link_cnt {
  font-size: 14px;
  display: inline-block;
  color: #3895ff;
  cursor: pointer;
  user-select: none;
  position: relative;

  &.danger {
    color: $text-primary;
    &:hover {
      color: $color-danger;
    }
  }

  .slider_container {
    position: absolute;
    z-index: 2;
    top: 30px;
    right: 0;
    background-color: #fff;
    border: 1px solid #e8eef8;
    box-shadow: 0 6px 5px 0 rgba(0, 0, 0, 0.03);
    // user-select:all;
    > s.top_arrows {
      position: absolute;
      width: 10px;
      height: 10px;
      border-left: 1px solid #e8eef8;
      border-top: 1px solid #e8eef8;
      background-color: #fff;
      right: 20px;
      top: -6px;
      z-index: 1;
      border-radius: 3px;
      transform: rotate(45deg);
    }
  }

  &.no_silder:hover {
    > i,
    > span {
      opacity: 0.5;
    }
  }

  &.no_silder:active {
    > i,
    > span {
      opacity: 1;
    }

    .slider_container {
      opacity: 1;
    }
  }

  &.lighter {
    i {
      font-weight: lighter;
    }
  }

  > i {
    font-size: 14px;
    color: $color-primary;
  }
  // =============是否加粗==============
  &.icon_blod > i {
    font-weight: bold;
  }
  // =============图标颜色==============
  &.blue,
  &.blue > i {
    color: $color-primary;
  }

  &.gray,
  &.gray > i {
    color: $text-primary;
  }

  &.rock,
  &.rock > i {
    color: #6985a3;
  }

  &.err_red,
  &.err_red > i {
    color: $color-danger;
  }

  // =================图标大小============
  &.bigger,
  &.bigger > i {
    font-size: 20px;
  }

  &.big,
  &.big > i {
    font-size: 18px;
  }

  &.medium,
  &.medium > i {
    font-size: 16px;
  }

  &.small,
  &.small > i {
    font-size: 14px;
  }

  &.smaller,
  &.smaller > i {
    font-size: 12px;
  }
  // 禁用样式
  &.disabled {
    opacity: 1 !important;
    cursor: no-drop;

    &:active,
    &:hover {
      > i,
      > span {
        opacity: 1 !important;
      }

      .slider_container {
        opacity: 1 !important;
      }
    }
  }
}

.link_cnt.silder {
  font-size: 14px;
}
</style>
